export type WeaponKind = "pistol" | "shotgun" | "rifle";

export interface WeaponConfig {
  readonly kind: WeaponKind;
  readonly displayName: string;
  readonly damagePerPellet: number;
  readonly pellets: number;
  readonly spreadRadians: number;
  readonly fireInterval: number;
  readonly magazineSize: number;
  readonly reloadDuration: number;
  readonly range: number;
}

export const WEAPON_CONFIGS: Readonly<Record<WeaponKind, WeaponConfig>> = {
  rifle: {
    kind: "rifle",
    displayName: "Автомат «Шквал-30»",
    damagePerPellet: 12,
    pellets: 1,
    spreadRadians: 0.024,
    fireInterval: 0.1,
    magazineSize: 30,
    reloadDuration: 1.7,
    range: 48,
  },
  pistol: {
    kind: "pistol",
    displayName: "Пистолет M12",
    damagePerPellet: 18,
    pellets: 1,
    spreadRadians: 0.008,
    fireInterval: 0.32,
    magazineSize: 12,
    reloadDuration: 1.15,
    range: 50,
  },
  shotgun: {
    kind: "shotgun",
    displayName: "Дробовик «Прорыв-8»",
    damagePerPellet: 11,
    pellets: 8,
    spreadRadians: 0.085,
    fireInterval: 0.9,
    magazineSize: 6,
    reloadDuration: 1.45,
    range: 34,
  },
};

export function calculatePelletDamage(config: WeaponConfig, pelletsHit: number): number {
  const clampedHits = Math.max(0, Math.min(config.pellets, Math.floor(pelletsHit)));
  return clampedHits * config.damagePerPellet;
}
